"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TextImage = _interopRequireDefault(require("@rsuite/icon-font/lib/file/TextImage"));

// Generated by script, don't edit it please.
var TextImage = (0, _createSvgIcon["default"])({
  as: _TextImage["default"],
  ariaLabel: 'text image',
  category: 'file',
  displayName: 'TextImage'
});
var _default = TextImage;
exports["default"] = _default;
module.exports = exports.default;